<template>
  <div class="pageDetail">
    <div class="bread">
      <el-button
        size="mini"
        plain
        type="primary"
        @click="$router.go(-1)"
      >
        <i class="el-icon-arrow-left" />返回
      </el-button>
      <span style="margin-left:12px;">
        <span
          class="breadHead"
        >网页管理</span>
        <span style="margin:0 9px;color:#C0C4CC;font-weight:700;">/</span>站点管理
      </span>
    </div>
    <div class="listHead">
      <div>
        <div class="sCircle" />
        <span style="font-size:16px;font-weight:700">资源内容链接列表</span>
      </div>
      <el-button
        v-if="$store.getters['global/loginInfo'].orgId === '1' "
        class="plainBtn"
        size="small"
        @click="showAddDialog"
      >
        新增站点
      </el-button>
    </div>
    <div
      class="layout-cont-box"
    >
      <the-condition
        multiple="identity"
        :limit="selectResult"
        @limit-change="init"
      >
        <tr
          key="else1"
          class="tab-row"
        >
          <td class="tab-cell tab-label">
            <span style="top:3px;position:relative;">单位筛选</span>
          </td>
          <td colspan="2">
            <el-select
              v-model="filterOrgid"
              class="select-ipt"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="请输入单位名称"
              :remote-method="remoteMethodCompany"
              @change="init"
            >
              <el-option
                v-for="item in companies"
                :key="item.orgId"
                :label="item.orgType == 2 && item.alias ? item.alias + '-' + item.name : item.orgType == 3 && item.alias ? item.alias : item.name"
                :value="item.orgId"
              />
            </el-select>
          </td>
          <td />
        </tr>
        <tr
          key="else"
          class="tab-row"
        >
          <td class="tab-cell tab-label">
            <span style="top:3px;position:relative;">输入搜索</span>
          </td>
          <td colspan="2">
            <el-input
              v-model="searchInput"
              style="margin-right:12px;"
              class="tab-ipt"
              size="small"
              autocomplete="off"
              placeholder="请输入站点名称进行搜索"
              @keyup.enter.native="init"
            />
            <el-button
              type="primary"
              size="small"
              @click="init"
            >
              搜索
            </el-button>
          </td>
          <td />
        </tr>
      </the-condition>
    </div>
    <div
      class="listHead"
      style="margin-top: 12px;"
    >
      <div>
        <div class="sCircle" />
        <span style="font-size:16px;font-weight:700;color: #A0A0A0;">数据列表</span>
      </div>
    </div>
    <div style="padding:16px 24px;background-color:#fff;">
      <el-table
        v-if="tableData.length > 0"
        :data="tableData"
        border
        :header-cell-style="headCss"
        style="width:100%;"
      >
        <el-table-column
          prop="siteId"
          label="ID"
          align="center"
          min-width="60"
        />
        <el-table-column
          label="站点名称"
          align="center"
          min-width="80"
        >
          <template slot-scope="{row}">
            <span
              :class="$store.getters['system/access'].includes('04201003') ? 'clickable' : ''"
              @click="goDetail(row)"
            >{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="模板编码"
          align="center"
          min-width="100"
        >
          <template slot-scope="{row}">
            <div v-if="row.h5Template !== null && row.h5Template !== ''">
              H5模板：{{ row.h5Template }}
            </div>
            <div v-if="row.webTemplate !== null && row.webTemplate !== ''">
              web模板：{{ row.webTemplate }}
            </div>
            <span v-if="row.h5Template === null && row.webTemplate === null">-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="orgName"
          label="所属单位"
          align="center"
          min-width="80"
        />
        <el-table-column
          label="单位类型"
          align="center"
          min-width="50"
        >
          <template slot-scope="{row}">
            <span>{{ orgTypeName[row.orgType] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="siteUserName"
          label="站长"
          align="center"
          min-width="50"
        />
        <el-table-column
          prop="isLogin"
          label="是否登录后访问"
          align="center"
          min-width="50"
        >
          <template slot-scope="{row}">
            <span>{{ row.isLogin === 1 ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="站点状态"
          align="center"
          min-width="50"
        >
          <template slot-scope="{row}">
            <span>{{ row.status === 1 ? '启用' : '禁用' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <div class="cell-hand">
              <mix-tooltip
                :enterable="false"
                content="站点信息"
                popper-class="user-table-tooltip weight"
                placement="top"
                effect="light"
              >
                <span
                  class="tab-handler tab-info"
                  @click="goInfo(scope.row.siteId,scope.row)"
                />
              </mix-tooltip>
              <template v-if="authority">
                <mix-tooltip
                  v-if="scope.row.status === 0 "
                  :enterable="false"
                  content="启用"
                  popper-class="user-table-tooltip weight"
                  placement="top"
                  effect="light"
                >
                  <span
                    class="tab-handler tab-able"
                    @click="changeAble(scope.row.siteId, 1)"
                  />
                </mix-tooltip>
                <mix-tooltip
                  v-if="scope.row.status === 1 "
                  :enterable="false"
                  content="禁用"
                  popper-class="user-table-tooltip weight islocked"
                  placement="top"
                  effect="light"
                >
                  <span
                    class="tab-handler tab-disable"
                    @click="changeAble(scope.row.siteId, 0)"
                  />
                </mix-tooltip>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div
        v-else
        style="width:100%;text-align:center;color:#aaa;"
      >
        <img src="../../../../assets/image/no_data.png">
      </div>
    </div>
    <el-pagination
      v-show="pagination.total > 0"
      background
      :page-sizes="pageSizes"
      :page-size.sync="pagination.size"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="pagination.current"
      :total="pagination.total"
      @current-change="init"
      @size-change="sizeChange"
    />
    <!-- 新增站点 -->
    <mix-dialog
      ref="addDia"
      :modal="true"
      width="560px"
      class="right-dialog"
      :visible.sync="showAddDia"
      @close="handleClose"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>新增站点</span>
      </div>
      <div
        v-if="showAddDia"
        class="dialogBody min-scrollbar"
      >
        <div class="dialogBodyTitle">
          站点信息 <div style="height:1px;width:88%;background-color:#ccc;" />
        </div>
        <div class="dialogBodyContent">
          <page-form
            v-if="showAddDia"
            ref="pageForm"
            :form="siteForm"
            mode="add"
          />
        </div>
        <div class="dialogBodyTitle">
          维护人员 <div style="height:1px;width:88%;background-color:#ccc;" />
        </div>
        <div class="dialogBodyContent">
          <el-form
            ref="peopleForm"
            :rules="peopleRules"
            :model="peopleForm"
            label-width="120px"
          >
            <el-form-item
              prop="siteOwner"
              label="站长"
            >
              <el-select
                v-model="peopleForm.siteOwner"
                filterable
                remote
                placeholder="请输入用户姓名"
                :remote-method="remoteMethod"
              >
                <el-option
                  v-for="item in allUsers"
                  :key="item.userId"
                  :label="item.realName"
                  :value="item.userId"
                >
                  <span>{{ item.realName + ' （' + item.orgUserName + '） --' + item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div
        class="add-match"
      >
        <transition name="el-zoom-in-bottom">
          <div class="btn-box-fixed">
            <el-button
              size="medium"
              class="plainBtn"
              @click="showAddDia=false"
            >
              取消
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="onSubmit('peopleForm')"
            >
              提交
            </el-button>
          </div>
        </transition>
      </div>
    </mix-dialog>
    <!-- 站点信息 -->
    <mix-dialog
      ref="editDia"
      :modal="true"
      width="560px"
      class="right-dialog"
      :visible.sync="showEditDia"
      @close="handleClose"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>站点信息</span>
      </div>
      <div class="dialogBody">
        <div class="dialogBodyContent">
          <el-tabs
            v-model="activeName"
            stretch
          >
            <!-- 站点信息页 -->
            <el-tab-pane
              label="站点信息"
              name="pageInfo"
            >
              <page-form
                v-if="showEditDia"
                ref="pageForm"
                :form="siteForm"
                mode="edit"
              />
            </el-tab-pane>
            <!-- 维护人员页 -->
            <el-tab-pane
              label="维护人员"
              name="workers"
            >
              <el-form
                v-if="workerForm.siteOwner.userName"
                ref="workerForm"
                :rules="workerRules"
                :model="workerForm"
                label-width="80px"
              >
                <el-form-item
                  prop="siteOwner"
                  label="站长"
                >
                  <div class="workerDiv">
                    <el-image
                      class="el-img"
                      :src="workerForm.siteOwner.avatarUrl"
                    >
                      <div
                        slot="error"
                        class="image-slot"
                      >
                        <div class="el-img">
                          {{ workerForm.siteOwner.userName.substr(-2, 2) }}
                        </div>
                      </div>
                    </el-image>
                    <div class="workerDivRight">
                      <span :title="workerForm.siteOwner.userName">{{ workerForm.siteOwner.userName.length > 5 ? workerForm.siteOwner.userName.substr(0,5) + '...' : workerForm.siteOwner.userName }}</span>
                      <span>{{ workerForm.siteOwner.phone ? workerForm.siteOwner.phone : '133xxxxxxxx' }}</span>
                    </div>
                    <img
                      v-if="$store.getters['system/access'].includes('04201002')"
                      class="delete-icon"
                      src="../../../../assets/icon/edit_worker_green.png"
                      @click="changeSiteOwner"
                    >
                  </div>
                </el-form-item>
                <el-form-item
                  prop="siteWorker"
                  label="编辑人员"
                >
                  <div style="display:flex;flex-wrap:wrap;">
                    <div
                      v-for="(item, index) in workerForm.siteWorker"
                      :key="index"
                      class="workerDiv"
                    >
                      <el-image
                        class="el-img"
                        :src="item.avatarUrl"
                      >
                        <div
                          slot="error"
                          class="image-slot"
                        >
                          <div class="el-img">
                            {{ item.userName.substr(-2, 2) }}
                          </div>
                        </div>
                      </el-image>
                      <div class="workerDivRight">
                        <span :title="item.userName">{{ item.userName.length > 5 ? item.userName.substr(0,5) + '...' : item.userName }}</span>
                        <span>{{ item.phone ? item.phone : '133xxxxxxxx' }}</span>
                      </div>
                      <img
                        v-if="$store.getters['system/access'].includes('04201002')"
                        class="delete-icon"
                        src="../../../../assets/icon/icon_worker_delete.png"
                        @click="deleteSiteWorker(item.userId)"
                      >
                    </div>
                  </div>
                  <el-button
                    v-if="$store.getters['system/access'].includes('04201002')"
                    style="margin-top:12px;"
                    size="medium"
                    type="primary"
                    @click="addWorker"
                  >
                    +添加编辑人员
                  </el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div
        v-if="authority "
        class="add-match"
      >
        <transition name="el-zoom-in-bottom">
          <div class="btn-box-fixed">
            <el-button
              size="medium"
              class="plainBtn"
              @click="showEditDia=false"
            >
              取消
            </el-button>
            <el-button
              size="medium"
              type="primary"
              @click="onSubmit('workerForm')"
            >
              提交
            </el-button>
          </div>
        </transition>
      </div>
    </mix-dialog>
    <!-- 添加成员模块 -->
    <el-dialog
      :close-on-click-modal="false"
      width="500px"
      :visible.sync="addMemberDialog"
      :append-to-body="true"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>{{ addMemberTitle }}</span>
      </div>
      <div class="cooperative-project-container">
        <div>
          <el-autocomplete
            v-model="add_member.userName"
            class="input-with-select"
            style="width:280px;"
            :hide-loading="true"
            :fetch-suggestions="querySearch"
            placeholder="请输入姓名/手机号进行搜索"
            @select="addToNewMember"
          />
          <el-button
            v-if="!(addMemberTitle === '修改站长' && newMembers.length > 0)"
            type="primary"
            style="float:right;"
            size="small"
            @click="addNewMember"
          >
            添加
          </el-button>
        </div>
        <div>
          <div style="margin-top:10px;">
            <span style="color:#999;margin-right:10px;">成员数</span>
            <span style="color:#999;">{{ newMembers.length }}人</span><br>
            <div
              v-for="(itm, index) in newMembers"
              :key="index"
              class="singleMember"
              style="margin-right:10px;margin-top:10px;"
            >
              {{ itm.userName }}
              <i
                class="el-icon-close close-span"
                style="cursor:pointer;"
                @click="deleteNewMember(itm, index)"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="small"
          class="btn-plain"
          @click="addMemberDialog=false"
        >
          取 消
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="confirmAddNewMember"
        >
          确 认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../proxy';
import TheCondition from '../../../common/TheCondition';
import pageForm from './pageForm';
import { pageSizes } from '@/lib/utils';
import emojiRegex from 'emoji-regex';
export default {
    name: 'PageDetail',
    components: { TheCondition, pageForm },
    data () {
        return {
            filterOrgid: '',
            companies: [], // 筛选里的全部单位
            allUsers: [], // 添加编辑人员里，搜出来的全部用户
            orgTypeName: {
                '0': '优学派',
                '1': '学校',
                '2': '代理',
                '3': '区域',
                '4': '联盟',
            },
            newMembers: [], // 即将新增的成员
            addMemberDialog: false,
            addMemberTitle: '',
            add_member: {}, // 新增的成员
            activeName: 'pageInfo',

            workerForm: { // 站点信息的编辑人员form
                siteOwner: {},
                siteWorker: [],
            },
            workerRules: {
                siteOwner: {
                    required: true,
                    message: '请选择站长',
                },
            },

            peopleForm: { // 新增站点的站长form
                siteOwner: '',
            },
            peopleRules: {
                siteOwner: {
                    required: true,
                    message: '请选择站长',
                },
            },

            siteForm: { // 站点信息form
                id: '',
                name: '', // 站点名称
                logo: '', // 站点logo
                orgType: '0',
                orgId: '1',
                description: '', // 网站描述
                webTemplate: '', // 网站web模板
                h5Template: '', // 网站H5模板
                address: '', // 网站访问地址
                addressId: '', // 网站访问id
                level: '3', // 栏目层级
                isLogin: 1,
                copyright: '', // 版权信息
                icpFilingCode: '', // ICP备案号
                policeFilingCode: '', // 公安备案号
            },
            headCss: { 'background-color': '#F1FFFA' }, // 表头样式
            tableData: [],
            searchInput: '',
            selectResult: {
                companyType: '', // 所属单位类型
                pageActive: '', // 站点状态
            },
            showAddDia: false,
            showEditDia: false,
            pagination: {
                total: 1,
                current: 1,
                size: 10,
            },
            pageSizes,
        };
    },
    computed: {
        identity () {
            return this.$store.getters['system/getSiteList'][0] ? this.$store.getters['system/getSiteList'][0].identity : null;
        },
        userIdentity () {
            return this.$store.getters['global/userIdentity'];
        },
        authority () {
            return this.userIdentity === 1 || this.userIdentity === 2;
        },
    },
    watch: {
        userIdentity () {
            this.changeSelectOption();
        },
    },
    created () {
        this.changeSelectOption();
    },
    mounted () {
        this.init();
    },
    methods: {
        changeSelectOption () {
            if (this.userIdentity > 2) {
                delete this.selectResult.companyType;
            } else {
                this.selectResult.companyType = '';
            }
        },
        // 供使用者调用
        trim (s) {
            return this.trimRight(this.trimLeft(s));
        },
        // 去掉左边的空白
        trimLeft (s) {
            if (s == null) {
                return '';
            }
            var whitespace = new String(' \t\n\r');
            var str = new String(s);
            if (whitespace.indexOf(str.charAt(0)) != -1) {
                var j = 0, i = str.length;
                while (j < i && whitespace.indexOf(str.charAt(j)) != -1) {
                    j++;
                }
                str = str.substring(j, i);
            }
            return str;
        },

        trimRight (s) {
            if (s == null) return '';
            var whitespace = new String(' \t\n\r');
            var str = new String(s);
            if (whitespace.indexOf(str.charAt(str.length - 1)) != -1) {
                var i = str.length - 1;
                while (i >= 0 && whitespace.indexOf(str.charAt(i)) != -1) {
                    i--;
                }
                str = str.substring(0, i + 1);
            }
            return str;
        },
        init () { // 获取站点列表
            let params = {
                orgType: this.selectResult.companyType,
                status: this.selectResult.pageActive,
                keyWord: this.trim(this.searchInput).toString(),
                siteOrgId: this.filterOrgid,
                pageNo: this.pagination.current,
                pageSize: this.pagination.size,
            };
            api.getWebsiteList(params).then((res) => {
                if (res.errcode === 0) {
                    this.tableData = res.data.list;
                    this.pagination.total = res.data.totalCount;
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        install () {
            api.install().then(res => {
                if (res.errcode === 0) {
                    if (res.data.length > 0) {
                        window.yxpapi.store.commit('system/mu_siteList', res.data);
                        // window.yxpapi.store.dispatch('getActionForApp');
                        if (window.yxpapi.store.getters['system/access'].indexOf('04299001') === -1) {
                            window.yxpapi.store.commit('system/mu_actionCodes', [{
                                actions: [
                                    {
                                        code: '04299001',
                                        name: '有前台权限',
                                    },
                                ],
                                authType: 'custom',
                            }]);
                        }
                    } else {
                        let actionCodes = JSON.parse(JSON.stringify(window.yxpapi.store.state.system.actionCodes));
                        let index = -1;
                        actionCodes.forEach((item, i) => {
                            if (item.actions[0].code === '04299001') index = i;
                        });
                        if (index > -1) {
                            actionCodes.splice(index, 1);
                            window.yxpapi.store.commit('system/mu_siteList', []);
                            window.yxpapi.store.commit('system/set_actionCodes', actionCodes);
                        }
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        remoteMethod (query) { // 输入名称获取user
            let me = this;
            if (query !== '') {
                setTimeout(() => {
                    let params = {
                        userName: query, // 手机号，名称
                    };
                    api.searchUser(params).then((res) => {
                        if (res.errcode === 0) {
                            me.allUsers = res.data.list;
                        } else {
                            me.$message.error(res.errmsg);
                        }
                    });
                }, 200);
            } else {
                me.allUsers = [];
            }
        },
        confirmAddNewMember () { // 确认添加编辑人员
            if (this.newMembers.length === 0) {
                this.$message.error('请选择成员');
                return;
            }
            let arr = [];
            for (let itm of this.newMembers) {
                arr.push(itm.userId);
            }
            for (let itm of this.workerForm.siteWorker) {
                arr.push(itm.userId);
            }
            if (this.addMemberTitle === '修改站长') {
                let params = {
                    siteId: this.siteForm.id,
                    userId: arr[0],
                };
                api.updateStationmaster(params).then((res) => {
                    if (res.errcode === 0) {
                        this.$message.success('修改成功');
                        this.install();
                        this.addMemberDialog = false;
                        this.getWorkers();
                        this.init();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            } else { // 添加编辑人员
                let params = {
                    siteId: this.siteForm.id,
                    targetUserIds: arr,
                };
                api.addBatch(params).then((res) => {
                    if (res.errcode === 0) {
                        this.$message.success('添加成功');
                        this.addMemberDialog = false;
                        this.install();
                        this.getWorkers();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            }
        },
        deleteNewMember (itm, index) { // 成员 X按钮
            this.newMembers.splice(index, 1);
        },
        addToNewMember (data) { // 添加时选择某个成员
            this.add_member = data;
        },
        deleteSiteWorker (id) { // 删除编辑人员
            this.$confirm('确定删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params = {
                    siteId: this.siteForm.id,
                    targetUserId: id,
                };
                api.deleteUsers(params).then((res) => {
                    if (res.errcode === 0) {
                        this.$message.success('删除成功');
                        this.install();
                        this.getWorkers();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            });
        },
        changeSiteOwner () { // 修改站长
            this.newMembers = [];
            this.addMemberTitle = '修改站长';
            this.addMemberDialog = true;
        },
        addNewMember () { // 成员 添加按钮
            let me = this;
            if (!me.add_member.userId) {
                me.$message.error('请选择正确成员');
                return;
            }
            if (me.add_member.userName) {
                let result = me.newMembers.some(item => {
                    if (item.userId === me.add_member.userId) {
                        return true;
                    }
                });
                let result1 = me.workerForm.siteWorker.some(item => {
                    if (item.userId === me.add_member.userId) {
                        return true;
                    }
                });
                if (result || result1) {
                    me.$message.error('已存在该成员');
                } else {
                    me.newMembers.push(me.add_member);
                    me.add_member = {};
                }
            } else {
                me.$message.error('请选择成员');
            }
        },
        querySearch (queryString, cb) { // 搜索成员
            this.searchResult = [];
            if (queryString === undefined || queryString === '') {
                return;
            }
            let params = {
                userName: queryString, // 手机号，名称
            };
            api.searchUser(params).then(r => {
                if (r.errcode === 0) {
                    for (let i = 0; i < r.data.list.length; i++) {
                        let item = {
                            value: `${r.data.list[i].realName}（${r.data.list[i].orgUserName}）--${r.data.list[i].phone}`,
                            userId: r.data.list[i].userId,
                            userName: r.data.list[i].realName,
                            telephone: r.data.list[i].phone,
                        };
                        this.searchResult.push(item);
                    }
                } else {
                    this.$message.error(r.errmsg);
                    return;
                }
                cb(this.searchResult);
            });
        },
        addWorker () { // 打开添加编辑人员弹窗
            this.newMembers = [];
            this.addMemberTitle = '添加编辑人员';
            this.addMemberDialog = true;
        },
        showAddDialog () { // 打开新增站点弹窗
            this.siteForm = {
                id: '',
                name: '',
                logo: '',
                orgType: '0',
                orgId: '1',
                description: '',
                webTemplate: '',
                h5Template: '',
                address: '',
                addressId: '',
                level: '3',
                isLogin: 0,
                copyright: '', // 版权信息
                icpFilingCode: '', // ICP备案号
                policeFilingCode: '', // 公安备案号
            };
            this.peopleForm = {
                siteOwner: '',
            };
            this.showAddDia = true;
            this.$refs.addDia.watchConfirm(this.siteForm);
            this.$refs.addDia.watchConfirm(this.peopleForm);
        },
        handleClose () { // 关闭弹窗清空数据
            this.siteForm = {
                name: '',
                logo: '',
                orgType: '0',
                orgId: '1',
                description: '',
                webTemplate: '',
                h5Template: '',
                address: '',
                addressId: '',
                level: '3',
                copyright: '', // 版权信息
                icpFilingCode: '', // ICP备案号
                policeFilingCode: '', // 公安备案号
            };
            this.peopleForm = {
                siteOwner: '',
            };
        },
        goInfo (val) { // 查看站点信息
            this.activeName = 'pageInfo';
            let params = {
                siteId: val,
            };
            api.websiteInfo(params).then((res) => {
                if (res.errcode === 0) {
                    this.siteForm.id = res.data.value.id;
                    this.siteForm.name = res.data.value.name;
                    this.siteForm.logo = res.data.value.logo;
                    this.siteForm.orgType = String(res.data.value.orgType);
                    this.siteForm.orgId = res.data.value.orgId;
                    this.siteForm.orgName = res.data.value.orgName;
                    this.siteForm.description = res.data.value.description;
                    this.siteForm.webTemplate = res.data.value.webTemplate;
                    this.siteForm.h5Template = res.data.value.h5Template;
                    this.siteForm.address = res.data.value.websiteAddress;
                    this.siteForm.addressId = res.data.value.addressId;
                    this.siteForm.level = res.data.value.columnLevel;
                    this.siteForm.isLogin = res.data.value.isLogin;
                    this.siteForm.copyright = res.data.value.copyright;
                    this.siteForm.icpFilingCode = res.data.value.icpFilingCode;
                    this.siteForm.policeFilingCode = res.data.value.policeFilingCode;
                    this.showEditDia = true;
                    this.$refs.editDia.watchConfirm(this.siteForm);
                } else {
                    this.$message.error(res.errmsg);
                }
                this.getWorkers();
            });
        },
        getWorkers () { // 获取站点的工作人员
            let params = {
                siteId: this.siteForm.id,
            };
            api.maintainers(params).then((res) => {
                if (res.errcode === 0) {
                    this.workerForm.siteWorker = [];
                    for (let itm of res.data.list) {
                        if (itm.identity === 1) {
                            this.peopleForm.siteOwner = itm.userId;
                            this.workerForm.siteOwner = itm;
                        } else {
                            this.workerForm.siteWorker.push(itm);
                        }
                    }
                } else {
                    this.$message.error(res.errmsg);
                }
            });
        },
        goDetail (site) { // 跳转详情页
            if (this.$store.getters['system/access'].includes('04201003')) {
                this.$router.push({
                    name: 'front',
                    query: {
                        client: 'back',
                        siteId: site.siteId,
                        name: site.name,
                        stack: -1,
                    },
                });
                this.$store.commit('system/mu_superAuth', true);
            }
        },
        changeAble (id, status) { // 启用禁用
            this.$confirm(status == 1 ? '启用站点后，该站点将可以使用。确认启用？' : '禁用站点后，该站点将不可用。确认禁用？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params = {
                    siteId: id,
                    status: status,
                };
                api.updateValid(params).then((res) => {
                    if (res.errcode === 0) {
                        this.init();
                    } else {
                        this.$message.error(res.errmsg);
                    }
                });
            }).catch(() => {
            });
        },
        sizeChange (p) {
            this.pagination.size = p;
            this.init();
        },
        onSubmit (ref) { // 确认新增站点或者编辑站点
            console.log('siteForm:', this.siteForm);
            console.log('peopleForm:', this.peopleForm);
            this.$refs.pageForm.$refs.form.validate((valid1) => {
                this.$refs[ref].validate((valid2) => {
                    if (valid1 && valid2) {
                        const params = {
                            id: this.siteForm.id,
                            name: this.siteForm.name.replace(emojiRegex(), ''),
                            logo: this.siteForm.logo,
                            orgType: this.siteForm.orgType,
                            orgId: this.siteForm.orgType === '0' ? '1' : this.siteForm.orgId, // 站点单位
                            description: this.siteForm.description,
                            webTemplate: this.siteForm.webTemplate,
                            h5Template: this.siteForm.h5Template,
                            websiteAddress: this.siteForm.address,
                            addressId: this.siteForm.addressId,
                            columnLevel: this.siteForm.level,
                            userId: this.peopleForm.siteOwner,
                            isLogin: this.siteForm.isLogin,
                            copyright: this.siteForm.copyright,
                            icpFilingCode: this.siteForm.icpFilingCode,
                            policeFilingCode: this.siteForm.policeFilingCode,
                        };
                        api.saveWebsite(params).then((res) => {
                            if (res.errcode === 0) {
                                this.$message.success('保存成功');
                                this.showAddDia = false;
                                this.showEditDia = false;
                                this.install();
                                this.init();
                            } else {
                                this.$message.error(res.errmsg);
                            }
                        });
                    }
                });
            });
        },
        remoteMethodCompany (query) { // 输入名称获取user
            let me = this;
            if (query !== '') {
                setTimeout(() => {
                    let params = {
                        content: query,
                        pageNo: 1,
                        pageSize: 999,
                    };
                    api.listOrgByKeywords(params).then((res) => {
                        if (res.errcode === 0) {
                            me.companies = res.data.list;
                        } else {
                            me.$message.error(res.errmsg);
                        }
                    });
                }, 200);
            } else {
                me.companies = [];
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../../../sass/theme.scss";
.clickable {
    cursor: pointer;
    color: #2ED095;
}
.singleMember {
  padding: 0 8px;
  height: 26px;
  line-height: 26px;
  background-color: #eee;
  margin-right: 10px;
  display: inline-block;
  text-align: center;
  background: #dcfcf0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dialogBodyTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.dialogBodyContent {
    width: 100%;
    margin-top: 12px;
    margin-bottom: 12px;
    width: 96%;
}
.workerDiv {
    margin-bottom: 12px;
    position: relative;
    margin-right: 24px;
    width: 180px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px dashed #ccc;
    padding: 0 8px;
    .el-img {
        width: 60px;
        height: 60px;
        line-height: 60px;
        border-radius: 50%;
        overflow: hidden;
        font-size: 18px;
        text-align: center;
        color: #2693F1;
        background: #E7F4ff;
    }
    .delete-icon {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 14px;
        height: 14px;
        cursor: pointer;
    }
    .workerDivRight {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }
}
</style>
<style lang="scss">
.dialogBodyContent {
    .el-input, .el-textarea {
        width: 360px;
    }
}
.user-table-tooltip.el-tooltip__popper.weight.is-light {
    border-color: #2ED095;
    .popper__arrow {
        border-top-color: #2ED095;
    }
    &.islocked {
        border-color: #f3864b;
        .popper__arrow {
            border-top-color: #f3864b;
        }
    }
}
.tab-handler {
    color: #2ED095;
    cursor: pointer;
    display: inline-block;
    height: 30px;
    min-width: 30px;
    margin-right: 10px;
    &.tab-info {
        background: url("../../../../assets/icon/icon_view_grey.png") no-repeat center;
        &:hover {
            background-image: url('../../../../assets/icon/icon_view_green.png');
        }
    }
    &.tab-detail {
        background: url("../../../../assets/icon/icon_form_record_grey.png") no-repeat center;
        &:hover {
            background-image: url('../../../../assets/icon/icon_form_record_green.png');
        }
    }
    &.tab-able {
        background: url("../../../../assets/icon/icon_start_using_grey.png") no-repeat center;
        &:hover {
            background-image: url('../../../../assets/icon/icon_start_using_green.png');
        }
    }
    &.tab-disable {
        background: url("../../../../assets/icon/icon_disable_grey.png") no-repeat center;
        &:hover {
            background-image: url('../../../../assets/icon/icon_disable_orange.png');
        }
    }
}
body .el-table th.gutter{
    display: table-cell !important;
}
.add-match .el-button {
    width: 100px;
    height: 36px;
}
.dialogBody {
    width: 92%;
    // min-width: 560px;
    margin-left: 4%;
    height: 90%;
    overflow: auto;
}
.btn-box-fixed {
    position: fixed;
    bottom: 10px;
    height: 50px;
    width: 560px;
    background: #fff;
    z-index: 99;
    margin-bottom: 0px !important;
    display: flex;
    justify-content: center;
    align-items: center;
}
.plainBtn {
    border-color: #2ED095 !important;
    color: #2ED095;
}
.orangeBtn {
    border-color: #f3864b;
    color: #f3864b;
    &:hover {
        border-color: #f3864b;
        color: #f3864b;
        background-color: #fff;
    }
}
.bread {
    height: 56px;
    line-height: 56px;
    .breadHead {
        font-weight: 700;
        cursor: pointer;
        &:hover {
            color: #2ED095;
        }
    }
}
.tab-row .el-input {
    width: 280px;
    margin-right: 10px;
}
.listHead {
    padding-left: 24px;
    padding-right: 24px;
    width: 100%;
    height: 53px;
    line-height: 53px;
    background-color: #fff;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.sCircle {
    margin-bottom: 2px;
    margin-right: 10px;
    display: inline-block;
    border: 2px solid #ccc;
    width: 10px;
    height: 10px;
    border-radius: 50%;
}
.pageDetail .select-ipt input {
    height: 32px !important;
    line-height: 32px !important;
}
</style>
